import { returnParseProjectElement } from "./project.controller";
import { storeLocal } from "./stores";

/**
 * Кеш форматтера валюты.
 *
 * Ключ — сам зашифрованный блоб проекта из localStorage: пока он не изменился,
 * валюта та же. Это избавляет от AES-расшифровки и JSON.parse на каждый ценник
 * и одновременно снимает необходимость вручную сбрасывать кеш при смене проекта.
 */
let cachedProject: any = null
let cachedFormatter: Intl.NumberFormat | null = null

export const getPrice = (price: number | string) => {
  const project = storeLocal.get('project')

  if (!cachedFormatter || project !== cachedProject) {
    const CURRENCY_CODE = returnParseProjectElement('CURRENCY_CODE')
    cachedFormatter = Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY_CODE })
    cachedProject = project
  }

  return cachedFormatter.format(Number(price))
}

let cachedShortProject: any = null
let cachedShortFormatter: Intl.NumberFormat | null = null

/** Коротко, для тесных ячеек: целыми, со знаком валюты вместо кода (950 ₽ вместо RUB 949.50) */
export const getPriceShort = (price: number | string) => {
  const project = storeLocal.get('project')

  if (!cachedShortFormatter || project !== cachedShortProject) {
    const CURRENCY_CODE = returnParseProjectElement('CURRENCY_CODE')
    cachedShortFormatter = Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: CURRENCY_CODE,
      currencyDisplay: 'narrowSymbol',
      maximumFractionDigits: 0,
    })
    cachedShortProject = project
  }

  return cachedShortFormatter.format(Math.round(Number(price)))
}
